import { render, staticRenderFns } from "./celebrity-program.vue?vue&type=template&id=7b82337e&lang=pug&"
import script from "./celebrity-program.vue?vue&type=script&lang=js&"
export * from "./celebrity-program.vue?vue&type=script&lang=js&"
import style0 from "./celebrity-program.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports